import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
/*Customer components*/
import CustomerLogin from '@/components/Login/CustomerLogin';
import CustomerForgotPassword from '@/components/Login/CustomerForgotPassword';
import CustomerResetPassword from '@/components/Login/CustomerResetPassword';
import UserResetPassword from '@/components/Login/UserResetPassword';
import CustomerOrderHistory from '@/components/Customer/CustomerOrderHistory';
import CustomerDashboard from '@/components/Customer/CustomerDashboard';
import CustomerUseParts from '@/components/Customer/CustomerUseParts';
import CustomerProfile from '@/components/Customer/CustomerProfile';

/*Backend components*/
import Login from '@/components/Login/Login';
import UserForgotPassword from '@/components/Login/UserForgotPassword';
import Dashboard from '@/components/Dashboard';
import OrderHistory from '@/components/OrderHistory';
import RolePermission from '@/components/RolePermission/RolePermission';
import Test from '@/components/Test';
import LocationsList from '@/components/Location/List';
import LocationsEdit from '@/components/Location/Edit';
import ListUser from '@/components/User/ListUser';
import AddUpdateUser from '@/components/User/AddUpdateUser';
import AddUpdateCustomer from '@/components/Customer/AddUpdateCustomer';
import ListCustomer from '@/components/Customer/ListCustomer';
import ListMember from '@/components/Customer/ListMember';
import AddUpdateMember from '@/components/Customer/AddUpdateMember';
import ListCustomerInventory from '@/components/Inventory/ListCustomerInventory'
import ImportParts from '@/components/Parts/ImportParts'
import AddUpdateParts from '@/components/Parts/AddUpdateParts'
import ListParts from '@/components/Parts/ListParts'
import AddUpdateInventory from '@/components/Inventory/AddUpdateInventory'
import ListInventory from '@/components/Inventory/ListInventory'
import ListInventoryParts from '@/components/Inventory/ListInventoryParts'
import AddUpdateInventoryPart from '@/components/Inventory/AddUpdateInventoryPart'
import GridQRCodeImages from '@/components/Inventory/GridQRCodeImages';
import ListAuditInventory from '@/components/AuditInventoryMaster/ListAuditInventory';
import DetailAuditInventory from '@/components/AuditInventoryMaster/DetailAuditInventory';
import DateWiseAuditInventory from '@/components/AuditInventoryMaster/DateWiseAuditInventory';
import CustomerAuditInventoryList from '@/components/Customer/CustomerAuditInventoryList';
import CustomerDateWiseAuditInventoryList from '@/components/Customer/CustomerDateWiseAuditInventoryList';
import UpdatePartDepletionHistory from '@/components/Parts/UpdatePartDepletionHistory';
import ListFormEmailManager from '@/components/FormEmailManagerMaster/ListFormEmailManager';
import AddUpdateFormEmailManager from '@/components/FormEmailManagerMaster/AddUpdateFormEmailManager';
import OPSCalendar from '@/components/OPSCalendarMaster/OPSCalendar';
import SyncResult from '@/components/InternalUseComponent/SyncResult';
import MobileApplication from '@/components/MobileApplicationMaster/MobileApplication';
import MultyAddUpdateFormEmailManager from '@/components/FormEmailManagerMaster/MultyAddUpdateFormEmailManager';
import NotFound from '@/components/NotFound.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/admin',
            name: 'Login',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/order-history',
            name: 'OrderHistory',
            component: OrderHistory
        },
        {
            path: '/rolepermissions',
            name: 'RolePermission',
            component: RolePermission
        },
        {
            path: '/locations',
            name: 'LocationsList',
            component: LocationsList
        },
        {
            path: '/location/create',
            name: 'LocationsCreate',
            component: LocationsEdit
        },
        {
            path: '/location/:id/edit',
            name: 'LocationsEdit',
            component: LocationsEdit
        },
        {
            path: '/list-user',
            name: 'ListUser',
            component: ListUser
        },
        {
            path: '/audit/inventory/list',
            name: 'ListAuditInventory',
            component: ListAuditInventory
        },
        {
            path: '/date/wise/audit/inventory/list/:customerId',
            name: 'DateWiseAuditInventory',
            component: DateWiseAuditInventory
        },
        {
            path: '/audit/inventory/detail/:customerId',
            name: 'DetailAuditInventory',
            component: DetailAuditInventory
        },
        {
            path: '/add-user',
            name: 'AddUser',
            component: AddUpdateUser
        },
        {
            path: '/update-user/:id',
            name: 'UpdateUser',
            component: AddUpdateUser
        },
        {
            path: '/add-customer',
            name: 'AddCustomer',
            component: AddUpdateCustomer
        },
        {
            path: '/update-customer/:id',
            name: 'UpdateCustomer',
            component: AddUpdateCustomer
        },
        {
            path: '/list-customer',
            name: 'ListCustomer',
            component: ListCustomer
        },
        {
            path: '/member/list/:custId',
            name: 'ListMember',
            component: ListMember
        },
        {
            path: '/member/add/:id',
            name: 'AddUpdateMember',
            component: AddUpdateMember
        },
        {
            path: '/member/edit/:memberId',
            name: 'UpdateMember',
            component: AddUpdateMember
        },
        {
            path: '/list-customer-inventory/:custId',
            name: 'ListCustomerInventory',
            component: ListCustomerInventory
        },
        {
          path: '/list-inventory/:inventory_id/add-inventory-part',
          name: 'AddUpdateInventoryPart',
          component: AddUpdateInventoryPart
        },
        {
          path: '/form/email/manager/list',
          name: 'ListFormEmailManager',
          component: ListFormEmailManager
        },
        {
          path: '/form/email/manager/add',
          name: 'AddUpdateFormEmailManager',
          component: AddUpdateFormEmailManager
        },
        {
          path: '/form/email/manager/edit/:id',
          name: 'UpdateFormEmailManager',
          component: AddUpdateFormEmailManager
        },
        {
          path: '/calendar',
          name: 'OPSCalendar',
          component: OPSCalendar
        },
        {
            path: '/',
            name: 'CustomerLogin',
            component: CustomerLogin
        },
        {
            path: '/user/forgotpassword',
            name: 'UserForgotPassword',
            component: UserForgotPassword,
        },
        {
            path: '/user/resetpassword/:token',
            name: 'UserResetPassword',
            component: UserResetPassword,
        },
        {
            path: '/customer/forgotpassword',
            name: 'CustomerForgotPassword',
            component: CustomerForgotPassword,
        },
        {
            path: '/customer/resetpassword/:token',
            name: 'CustomerResetPassword',
            component: CustomerResetPassword,
        },
        {
            path: '/customer/order-history',
            name: 'CustomerOrderHistory',
            component: CustomerOrderHistory
        },
        {
            path: '/customer/profile',
            name: 'CustomerProfile',
            component: CustomerProfile
        },
        {
            path: '/customer/dashboard',
            name: 'CustomerDashboard',
            component: CustomerDashboard
        },
        {
            path: '/customer/list-inventory',
            name: 'ListInventory',
            component: ListInventory
        },
        {
            path: '/customer/add-inventory',
            name: 'AddInventory',
            component: AddUpdateInventory
        },
        {
            path: '/customer/update-inventory/:id',
            name: 'UpdateInventory',
            component: AddUpdateInventory
        },
        {
            path: '/customer/audit/inventory',
            name: 'CustomerAuditInventoryList',
            component: CustomerAuditInventoryList
        },
        {
            path: '/customer/date/wise/audit/inventory',
            name: 'CustomerDateWiseAuditInventoryList',
            component: CustomerDateWiseAuditInventoryList
        },
        {
          path: '/import-parts',
          name: 'ImportParts',
          component: ImportParts
        },
        {
            path: '/add-parts',
            name: 'AddParts',
            component: AddUpdateParts
        },
        {
            path: '/update-part/:id',
            name: 'UpdatePart',
            component: AddUpdateParts
        },
        {
            path: '/list-parts',
            name: 'ListParts',
            component: ListParts
        },
        {
            path: '/customer/list-inventory/:id/list-parts',
            name: 'ListInventoryParts',
            component: ListInventoryParts
        },
        {
            path: '/customer/list-inventory/:inventory_id/add-inventory-part',
            name: 'AddUpdateInventoryPart',
            component: AddUpdateInventoryPart
        },
        {
            path: '/list-inventory/:inventory_id/update-inventory-part/:id',
            name: 'UpdateInventoryPart',
            component: AddUpdateInventoryPart
        },
        {
            path: '/qrcode/print',
            name: 'GridQRCodeImages',
            component: GridQRCodeImages
        },
        {
            path: '/customer/use-parts',
            name: 'CustomerUseParts',
            component: CustomerUseParts
        },
        {
            path: '/partdepletion/edit/:id',
            name: 'UpdatePartDepletionHistory',
            component: UpdatePartDepletionHistory
        },
        {
            path: '/sync/result',
            name: 'SyncResult',
            component: SyncResult
        },
        {
            path: '/mobile/application',
            name: 'MobileApplication',
            component: MobileApplication
        },
        {
            path: '/edit/multiple/form/email/manager',
            name: 'MultyAddUpdateFormEmailManager',
            component: MultyAddUpdateFormEmailManager
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: NotFound,
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js